import type { ICommand } from '@model-framework/command';
import type { IOrderRollback } from '@model-framework/display-order/domain';
import type { NodeId, StickyZoneId } from 'balus-common';
import type { DisplayOrderRepository } from '@model-framework/display-order/infrastructure';

export class StickyZoneChangeParentZoneCommand implements ICommand {
  private orderRollback: IOrderRollback | undefined;

  constructor(
    private readonly childIds: (NodeId | StickyZoneId)[],
    private readonly newParentZoneIds: StickyZoneId[],
    private readonly displayOrderRepository: DisplayOrderRepository
  ) {}

  do(): void {
    this.displayOrderRepository
      .changeParentZones(this.childIds, this.newParentZoneIds)
      .then((orderRollback) => (this.orderRollback = orderRollback));
  }

  undo(): void {
    if (!this.orderRollback) return;
    this.displayOrderRepository.rollback(this.orderRollback);
  }

  redo(): void {
    this.do();
  }

  async canUndo(): Promise<boolean> {
    return !!this.orderRollback;
  }

  async canRedo(): Promise<boolean> {
    return !!this.orderRollback;
  }
}
